/* Ofertas de brinde ("compre X, ganhe Y"): coloca e tira os brindes do carrinho.
   As ofertas vêm do app "YouShine Brinde Gel" (cadastro "Oferta de brinde" no admin), que as
   sincroniza no metacampo lido em layout/theme.liquid (#ds-brinde-regras). O preço do brinde vem
   das promoções: Yampi no checkout e o desconto do app na sacola.
   Para cada produto de brinde:
   - ganhou direito a mais brindes -> entram;
   - perdeu direito -> saem só os brindes (o que o cliente comprou à parte fica);
   - o cliente pode tirar o brinde; ele só volta se ganhar direito a mais;
   - "+" no brinde = unidade paga; "−" volta ao brinde. */
(function () {
  var el = document.getElementById('ds-brinde-regras');
  var cfg = null;
  try { cfg = JSON.parse((el && el.textContent) || 'null'); } catch (e) {}
  var regras = (cfg && Array.isArray(cfg.regras)) ? cfg.regras : [];
  if (!regras.length) return;

  var num = function (gid) { return Number(String(gid).split('/').pop()); };
  regras = regras.map(function (r) {
    return {
      gatilho: (r.gatilho || []).map(num),
      quantidade: Math.max(1, Number(r.quantidade) || 1),
      brinde: num(r.brinde),
      quantidadeBrinde: Math.max(1, Number(r.quantidadeBrinde) || 1),
      limite: Number(r.limite) > 0 ? Number(r.limite) : Infinity
    };
  }).filter(function (r) { return r.gatilho.length && r.brinde; });
  var brindes = regras.map(function (r) { return r.brinde; }).filter(function (v, i, a) { return a.indexOf(v) === i; });

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var origFetch = window.fetch.bind(window);
  var busy = false, again = false, timer = null;

  function memo(token, v) {
    try {
      if (v === undefined) return JSON.parse(localStorage.getItem('ds-brinde:' + token) || 'null');
      localStorage.setItem('ds-brinde:' + token, JSON.stringify(v));
    } catch (e) { return null; }
  }
  function post(path, body) {
    return origFetch(root + path, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function sectionIds() {
    return [].map.call(document.querySelectorAll('cart-items-component'), function (c) { return c.dataset.sectionId; }).filter(Boolean);
  }
  function qtyOf(cart, variantId) {
    return cart.items.reduce(function (s, i) { return s + (i.variant_id === variantId ? i.quantity : 0); }, 0);
  }

  // quantas unidades de cada brinde o carrinho dá direito
  function direitos(cart, memoria) {
    var d = {};
    regras.forEach(function (r) {
      var unidades = cart.items.reduce(function (s, i) { return s + (r.gatilho.indexOf(i.variant_id) >= 0 ? i.quantity : 0); }, 0);
      if (r.gatilho.indexOf(r.brinde) >= 0) unidades -= ((memoria[r.brinde] || {}).gift || 0); // o brinde não conta para si
      var vezes = Math.min(r.limite, Math.floor(Math.max(0, unidades) / r.quantidade));
      d[r.brinde] = (d[r.brinde] || 0) + vezes * r.quantidadeBrinde;
    });
    return d;
  }

  async function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    try {
      var cart = await origFetch(root + 'cart.js', {headers: {Accept: 'application/json'}}).then(function (r) { return r.json(); });
      if (cart.attributes._ds_brinde !== '1') cart = await post('cart/update.js', {attributes: {_ds_brinde: '1'}});
      var memoria = memo(cart.token) || {};
      var direito = direitos(cart, memoria);
      var mudancas = [];
      brindes.forEach(function (v) {
        var st = memoria[v] || {direito: 0, gift: 0};
        var noCarrinho = qtyOf(cart, v);
        var e = direito[v] || 0;
        if (noCarrinho < st.gift) st.gift = noCarrinho;            // o cliente tirou o brinde
        var delta = 0;
        if (e > st.direito) delta = e - st.direito;                 // ganhou mais brinde
        else if (e < st.direito) delta = -Math.min(st.gift, Math.max(0, st.gift - e)); // perdeu
        st.gift += delta; st.direito = e; memoria[v] = st;
        if (delta) mudancas.push({variant: v, delta: delta});
      });
      memo(cart.token, memoria);
      if (!mudancas.length) return;

      var ids = sectionIds(), res = null;
      for (var m = 0; m < mudancas.length; m++) {
        var ch = mudancas[m];
        if (ch.delta > 0) {
          var add = {items: [{id: ch.variant, quantity: ch.delta}]};
          if (ids.length) add.sections = ids.join(',');
          res = await post('cart/add.js', add);
        } else {
          var left = -ch.delta;
          while (left > 0) {
            var atual = await origFetch(root + 'cart.js', {headers: {Accept: 'application/json'}}).then(function (r) { return r.json(); });
            var linhas = atual.items.filter(function (i) { return i.variant_id === ch.variant; });
            var ultima = linhas[linhas.length - 1];
            if (!ultima) break;
            var take = Math.min(left, ultima.quantity);
            var body = {id: ultima.key, quantity: ultima.quantity - take};
            if (ids.length) body.sections = ids.join(',');
            res = await post('cart/change.js', body);
            left -= take;
          }
        }
      }
      var ev = new Event('cart:update', {bubbles: true});
      ev.detail = {resource: undefined, sourceId: 'ds-brinde', data: {source: 'ds-brinde', itemCount: res && res.item_count, sections: res && res.sections}};
      document.dispatchEvent(ev);
    } catch (e) {
      /* sem brinde automático desta vez; o checkout continua cobrando pelas promoções */
    } finally {
      busy = false;
      if (again) { again = false; schedule(); }
    }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(reconcile, 350); }

  // toda mudança de carrinho feita pela página, pelo tema ou por apps passa por aqui
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) p.then(function () { schedule(); }, function () {});
    return p;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
